/**
 * @description: 主页面
 * @author: fire
 * @update: hwx
 */
<template>
	<div class="index_content">
		<div class="ic-wrapper">
			<!-- 侧边栏 -->
			<div class="sidebar">
				<div class="sidebar-scroll">
					<div class="sidebar-main">
						<!-- 一级菜单 -->
						<h2>{{selectedMenu.name}}</h2>
						<el-menu class="el-menu-side" :default-active="active_sidebar">
							<div v-for="item in selectedMenu.submenu" :key="item.id">
								<el-submenu v-if="item.id=='565' || item.id=='566' || item.id=='567' || item.id=='568' || item.id=='877' || item.id=='878' || item.id=='879' || item.id=='1108' || item.id=='1112' || item.id=='1239' || item.id=='1270' || item.id=='1380'" :index="item.id">
									<template slot="title">{{item.name}}</template>
									<!-- 三级菜单 -->
									<el-menu-item v-for="subitem in item.submenu" :key="subitem.id" :index="subitem.id" @click="thirdMenu(selectedMenu, item, subitem)">
										{{subitem.name}}
									</el-menu-item>
								</el-submenu>
								<!-- 二级菜单 -->
								<el-menu-item v-else :index="item.id" @click="secondMenu(selectedMenu, item)">{{item.name}}</el-menu-item>
							</div>
						</el-menu>
					</div>
				</div>
			</div>
			<div class="main-content">
				<el-tabs
					type="card"
					closable
					class="main-content-tabs"
					ref="main_content_tabs"
					v-model="active_tab_name"
					@tab-click="changeSelectTab"
					@tab-remove="removeSelectTab"
				>
					<el-tab-pane
						v-for="item in selectTabs"
						:key="item.id"
						:label="item.label"
						:name="item.name"
					>
						<component :is="pages[item.name]" @pageLink="pageLink"></component>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</div>
</template>

<script>
	import * as types from '@/store/types';
	import pages from '@/router/pages';

	export default {
		name: '',
		data() {
			return {
				pages: pages,
				active_sidebar: '',
				active_tab_name: ''
			}
		},
		computed: {
			selectedMenu() {
				return this.$store.state.selectedMenu
			},
			selectTabs() {
				return this.$store.state.selectTabs
			},
		},
		mounted: function() {},
		methods: {
			// 点击二级菜单
			secondMenu(selectedMenu, submenuItem) {
				const urlPush = "/" + selectedMenu.url + "/" + submenuItem.url
				const isIdentical = this.selectTabs.find(item => item.id == submenuItem.id)
				if(typeof isIdentical == "undefined") {
					// 页面未选中
					this.$store.commit(types.SELECTTABS, {
						id: submenuItem.id,
						label: submenuItem.name,
						name: submenuItem.url,
						url: urlPush,
						redirect_url: submenuItem.redirect_url || ''
					})
				}
				this.active_sidebar = submenuItem.id
				this.active_tab_name = submenuItem.url
				this.$router.push({ 'path': urlPush })
			},
			// 点击三级菜单
			thirdMenu(selectedMenu, sencondItem, thirdItem) {
				const urlPush = `/${selectedMenu.url}/${sencondItem.url}/${thirdItem.url}`
				const isIdentical = this.selectTabs.find(item => item.id == thirdItem.id)
				// 若已打开的tab页含有iframe，则需先关闭，防止出错
				const report_system_tab_index = this.selectTabs.findIndex(item => item.name == 'report_system_index')
				if (report_system_tab_index > -1 && typeof isIdentical == "undefined" && thirdItem.url == 'report_system_index') { 
					this.removeSelectTab(this.selectTabs[report_system_tab_index].name)
				}
				if(typeof isIdentical == "undefined") {
					// 页面未选中
					this.$store.commit(types.SELECTTABS, {
						id: thirdItem.id,
						label: thirdItem.name,
						name: thirdItem.url,
						url: urlPush,
						redirect_url: thirdItem.redirect_url || ''
					})
				}
				this.active_sidebar = thirdItem.id
				this.active_tab_name = thirdItem.url
				if(urlPush.indexOf("report_system_index") > -1) { // 报表系统
					let to = thirdItem.redirect_url || ''
					this.$router.push({ name: 'report_system_index', params: { to: to} })
				}else {
					this.$router.push({ 'path': urlPush })
				}
			},
			// 点击tab
			changeSelectTab() {
				this.selectTabs.forEach(item => {
					if(item.name === this.active_tab_name) {
						this.active_sidebar = item.id
						if((item.url && item.url.indexOf("report_system_index") > -1 ) || item.name.indexOf("report_system_index") > -1) { // 报表系统
							let to = item.redirect_url || ''
							this.$router.push({ name: 'report_system_index', params: { to: to} })
						}else {
							this.$router.push({'path': item.url})
						}
					}
				})
			},
			// 关闭tab
			removeSelectTab(targetName) {
				if(this.selectTabs.length > 1) {
					let tabs = this.selectTabs;
					let activeName = this.active_tab_name;
					if(activeName === targetName) {
						tabs.forEach((tab, index) => {
							if(tab.name === targetName) {
								let nextTab = tabs[index + 1] || tabs[index - 1];
								if(nextTab) {
									activeName = nextTab.name;
								}
								this.active_sidebar = nextTab.id
								if(nextTab.url.indexOf("report_system_index") > -1 || nextTab.name.indexOf("report_system_index") > -1) { // 报表系统
									let to = nextTab.redirect_url || ''
									this.$router.push({ name: 'report_system_index', params: { to: to} })
								}else {
									this.$router.push({'path': nextTab.url})
								}
							}
						});
					}
					this.active_tab_name = activeName;
					this.$store.commit(types.SELECTTABSDELETE, targetName)
				}
			},
			// 页面跳转
			pageLink(submenuItem, obj) {
				const isIdentical = this.selectTabs.find(item => item.id == submenuItem.id)
				// 若已打开的tab页含有iframe，则需先关闭，防止出错
				const report_system_tab_index = this.selectTabs.findIndex(item => item.name == 'report_system_index')
				if (report_system_tab_index > -1 && typeof isIdentical == "undefined" && submenuItem.url == 'report_system_index') { 
					this.removeSelectTab(this.selectTabs[report_system_tab_index].name)
				}
				if(typeof isIdentical == "undefined") {
					// 页面未选中
					this.$store.commit(types.SELECTTABS, {
						id: submenuItem.id,
						label: submenuItem.name,
						name: submenuItem.url,
						redirect_url: submenuItem.redirect_url || ''
					})
				}
				this.$router.push(obj);
				this.active_sidebar = submenuItem.id
				this.active_tab_name = submenuItem.url
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.index_content {
		height: 100%;
		.ic-wrapper {
			display: flex;
			justify-content: space-between;
			height: 100%;
			padding: 0;
			.sidebar {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 18%;
				height: 100%;
				padding: 0 20px 0 0;
				background-color: @white;
				.sidebar-scroll {
					overflow-y: scroll;
					width: 100%;
					height: 80%;
					h2 {
						padding-left: 20px;
						font-size: 20px;
					}
					.el-menu--inline {
						background: #f5f5f5;
					}
				}
			}
			.main-content {
				width: 82%;
				height: 100%;
				.main-content-tabs {
					display: flex;
					flex-direction: column;
					height: 100%;
					margin-left: 15px;
					background: @white;
					>div.el-tabs__header {
						margin: 0 0 10px;
						.el-tabs__nav {
							height: 41px;
						}
					}
					>div.el-tabs__content {
						overflow-y: auto;
						flex: 1;
						padding: 0 10px 10px;
					}
				}
			}
			@media (max-width: 992px) {
				.sidebar {
					width: 25%
				}
				.main-content {
					width: 75%
				}
			}
		}
	}
</style>